import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css'; // Ensure CSS is imported so Vite bundles it
import './src/i18n'; // Initialize i18n

// 1. Define the Mount Function
// This allows the widget.js script to manually trigger rendering inside the Shadow DOM
declare global {
  interface Window {
    WidgetFlow: {
      mount: (container: HTMLElement | ShadowRoot, props: any) => void;
    };
  }
}

const mount = (container: HTMLElement | ShadowRoot, props: any = {}) => {
  const root = ReactDOM.createRoot(container as HTMLElement);
  root.render(
    <React.StrictMode>
      {/* 
         If props.mode is 'embed', App.tsx will detect it via props 
         instead of just URL params, making it more robust.
      */}
      <div id="widgetflow-container">
        <App embedId={props.userId} />
      </div>
    </React.StrictMode>
  );
};

// Expose to global scope for widget.js
window.WidgetFlow = { mount };

// 2. Auto-Mount for Dashboard (Standalone Mode)
// If we are on the main website (not embedded), mount to #root normally.
const rootElement = document.getElementById('root');
if (rootElement) {
  // Check if we are being loaded by the widget script (which might create a root but not use it the same way)
  // For simplicity, if #root exists and is empty, we mount the dashboard.
  if (!rootElement.hasChildNodes()) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <div id="widgetflow-container">
          <App />
        </div>
      </React.StrictMode>
    );
  }
}